import React, { useEffect, useState } from "react";
import { Container, Col, Row } from "react-bootstrap";
import axios from "axios";
import {
  EmailShareButton,
  FacebookShareButton,
  TelegramShareButton,
  ViberShareButton,
  FacebookMessengerShareButton,
  WhatsappShareButton,
} from "react-share";
import {
  FacebookIcon,
  TwitterIcon,
  EmailIcon,
  FacebookMessengerIcon,
  WhatsappIcon,
  TelegramIcon,
  ViberIcon,
} from "react-share";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Import the styles
function PoslednjiPozdrav({ post, modalIsOpen }) {
  const userRole = localStorage.getItem("userRole");
  const [imageSrc, setImageSrc] = useState(require("../assets/candle.png"));
  const [counter, setCounter] = useState(post.counter);
  const handleCandleClick = () => {
    // Toggle between two image sources
    if (imageSrc === require("../assets/candle.png")) {
      setImageSrc(require("../assets/candleColor.png"));
    } else {
      setImageSrc(require("../assets/candle.png"));
    }
    increaseCounter();
  };

  const increaseCounter = async () => {
    try {
      setCounter(post.counter + 1);
      await axios.post(
        `https://radojicictijanaa.pythonanywhere.com/api/posts/${post.id}/counter/up/`,
        {}
      );
    } catch (error) {
      console.log("Error fetching posts:", error);
    }
  };
  if (!post) {
    return <div>Loading...</div>;
  }
  const deletePosts = async () => {
    const accessToken = localStorage.getItem("accessToken");
    try {
      const response = await axios.delete(
        `https://radojicictijanaa.pythonanywhere.com/api/posts/${post.id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      window.location.href = "/";
    } catch (error) {
      console.log("Error fetching posts:", error);
    }
  };

  return (
    <Container
      data-aos={"fade-up"}
      id="pp"
      style={{
        border: "3px solid black",
        backgroundColor: "white",
        marginTop: "20px",
      }}
      className="post"
    >
      {" "}
      <Row>
        <p
          style={{
            fontStyle: "italic",
            border: "none",
            borderTop: "none",
            textAlign: "right",
            backgroundColor: "white",
            color: "gray",
          }}
        >
          {post.type === "poslednji_pozdrav" ? "poslednji pozdrav" : post.type}
        </p>
      </Row>
      <Row style={{ paddingTop: "3%", fontSize: "medium" }}>
        <p style={{ textAlign: "center" }}>{post.text_top}</p>
      </Row>
      <Row style={{ paddingTop: "0", justifyContent: "center" }}>
        {/* <Col className="d-flex justify-content-center">
          <img
            id="umrlica-icon"
            style={{
              height: "50px",
              width: "50px",
              border: "none",
            }}
            src={post.icon}
            alt="x"
          />
        </Col> */}
      </Row>
      <Row style={{ paddingTop: "3%" }}>
        <Col className=" justify-content-around"></Col>
        <Col className="d-flex justify-content-around">
          {post.images.length !== 0 && (
            <Carousel
              showThumbs={false}
              showArrows={false}
              infiniteLoop={true}
              autoPlay={true}
              interval={2500}
            >
              {post.images
                .reduce((p, c) => p + c)
                .split(",")
                .map((imagePath, index) => (
                  <div className="d-flex justify-content-center" key={index}>
                    <div
                      style={{
                        width: "120px",
                        height: "150px",
                        border: "3px solid black",
                        background: `url(https://radojicictijanaa.pythonanywhere.com/${imagePath})`,
                        backgroundSize: "cover",
                        backgroundPosition: "50% 50%",
                      }}
                    ></div>
                  </div>
                ))}
            </Carousel>
          )}
        </Col>
        <Col className="d-flex justify-content-around"></Col>
      </Row>
      <Row style={{ paddingTop: "2%", paddingBottom: "0%" }}>
        <Col className="d-flex justify-content-around"></Col>
        <Col
          style={{
            fontWeight: "bold",
            letterSpacing: "1.2px",
          }}
          className="d-flex justify-content-around"
        >
          {post.name}
        </Col>
        <Col className="d-flex justify-content-around"></Col>
      </Row>
      <Row style={{ paddingTop: "2%", paddingBottom: "3%" }}>
        <p style={{ textAlign: "center" }}>{post.main_text}</p>
      </Row>
      {modalIsOpen && (
        <Row>
          {" "}
          <span style={{ textAlign: "center" }}>Upali svijeću</span>
        </Row>
      )}
      {modalIsOpen && (
        <Row>
          {" "}
          <button
            style={{
              backgroundColor: "transparent",
              border: "none",
              alignItems: "center",
              borderRadius: "100%",
            }}
            onClick={handleCandleClick}
          >
            <img src={imageSrc} alt="Image" />
          </button>
        </Row>
      )}
      {modalIsOpen && (
        <Row style={{ paddingBottom: "0" }}>
          {" "}
          <span style={{ textAlign: "center" }}>{counter}</span>
        </Row>
      )}
      <Row style={{ float: "right" }}>
        <p style={{ paddingBottom: "5%", fontWeight: "bold" }}>
          {post.text_bottom}
        </p>
      </Row>
      <Row style={{ paddingTop: "5%" }}></Row>
      {modalIsOpen && (userRole === "admin" || userRole === "superadmin") && (
        <Col>
          <button className="btn btn-danger" onClick={() => deletePosts()}>
            Obriši
          </button>
        </Col>
      )}
      {modalIsOpen && (
        <div
          style={{ float: "right", paddingBottom: "2%", paddingRight: "1%" }}
        >
          <FacebookShareButton
            title="Facebook"
            url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
          >
            <FacebookIcon
              bgStyle={{ fill: "black" }}
              iconFillColor="white"
              size={25}
              round
            />
          </FacebookShareButton>
          <span title="Viber">
            <ViberShareButton
              url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
            >
              <ViberIcon
                bgStyle={{ fill: "black" }}
                iconFillColor="white"
                size={25}
                round
              />
            </ViberShareButton>
          </span>
          <EmailShareButton
            title="Email"
            url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
            subject="Check out this post"
          >
            <EmailIcon
              bgStyle={{ fill: "black" }}
              iconFillColor="white"
              size={25}
              round
            />
          </EmailShareButton>
          <FacebookMessengerShareButton
            title="Messenger"
            url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
          >
            <FacebookMessengerIcon
              bgStyle={{ fill: "black" }}
              iconFillColor="white"
              size={25}
              round
            />
          </FacebookMessengerShareButton>
          <span title="Telegram">
            <TelegramShareButton
              title="Telegram"
              url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
            >
              <TelegramIcon
                bgStyle={{ fill: "black" }}
                iconFillColor="white"
                size={25}
                round
              />
            </TelegramShareButton>
          </span>
          <span title="What's App">
            <WhatsappShareButton
              url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
              title="Check out this post"
            >
              <WhatsappIcon
                bgStyle={{ fill: "black" }}
                iconFillColor="white"
                size={25}
                round
              />
            </WhatsappShareButton>
          </span>
        </div>
      )}
    </Container>
  );
}

export default PoslednjiPozdrav;
